import { createContext } from "react";

export const UpdateCanvasLabelContext = createContext(null);
